import * as React from 'react';
import { addDays, format, isEqual } from 'date-fns';

// Material-UI
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

// Styles
import { useTheme } from '@mui/material/styles';

import {
  DateRange,
  RequestMeal
} from '../../models';

interface MealsMobileProps {
  dateRange: DateRange;
  nights: number;
  rows: Array<RequestMeal>;
}

const MealsMobile: React.FC<MealsMobileProps> = (props) => {

  // #region Styles

  const theme = useTheme();
  const styles = {
    root: {
      margin: theme.spacing(1, 0, 0, 0)
    },
    footer: {
      margin: theme.spacing(2, 0, 2, 0)
    },
    date: {
      borderTop: `1px solid ${theme.palette.divider}`,
      margin: theme.spacing(1, 0, 0, 0),
      padding: theme.spacing(1, 0, 1, 0)
    },
    noRows: {
      borderTop: `1px solid ${theme.palette.divider}`,
      margin: theme.spacing(3, 0, 0, 0),
      padding: theme.spacing(2, 0, 0, 0)
    },
  };

  // #endregion

  // #region Methods

  /*
  * Render nightly counts for the date range
  */
  const renderNightlyCounts = () => {

    let a: Array<JSX.Element> = [];
    if (props.rows.length === 0) {
      a.push(<Typography sx={styles.noRows}>No lodge use requests for the selected dates</Typography>);
    } else {
      const start = new Date(props.dateRange.startDate);

      // For each date in range
      for (var i = 0; i < props.nights; i++) {
        const date = addDays(start, i);

        // Add date header
        a.push(<Typography sx={styles.date}>{format(date, 'EEE M/d/y')}</Typography>);

        const b: Array<React.JSX.Element> = [];
        // Build array of counts for the date
        if (props.rows.length > 0) {
          props.rows.forEach(r => {
            const c = r.mealCounts.find(r => isEqual(new Date(r.lodgeNight), date));
            if (c !== undefined) {
              b.push(<Grid container spacing={2}><Grid size={6}><Typography>{r.category}</Typography></Grid><Grid size={6}><Typography>{c.count}</Typography></Grid></Grid>);
            }
          });
          if (b.length === 0) {
            a.push(<Typography>No confirmed lodge use requests</Typography>);
          } else {
            a = [...a, ...b];
          }
        }

      }

      return (a);

    }

  }

  return (
    <Box sx={styles.root}>
      {renderNightlyCounts()}
    </Box>
  );

}

export default MealsMobile;